export const hasLengthMoreThanZero = check => check?.length > 0;
